import { connect } from 'react-redux';
import { ReduxState } from '../../../ReduxStorage/state';
import {
  selectSamlSsoCohort,
  selectSamlIdProviders,
} from '../../../ReduxStorage/Institutions/InstitutionIdentityProviders/selectors';
import { SamlIdentityProviderPreLogin } from './component';

export const ConnectedSamlIdentityProviderPreLogin = connect(
  (state: ReduxState) => ({
    cohortId: selectSamlSsoCohort(state),
    idps: selectSamlIdProviders(state),
  }),
  null
)(SamlIdentityProviderPreLogin);
